<template>
    <v-system-bar
        app
        lights-out
        height="50"
        :color="color"
        :dark="darkTheme"
        v-show="showBar"
    >
        <v-icon
            v-if="userOptions && userOptions.sidebar"
            :color="userOptions.sidebar.isOpen ? 'white' : 'white'"
            :class="userOptions.sidebar.isOpen ? '' : 'bouncing-icon'"
            @click="toggleUserOptions('sidebar.isOpen')"
            >{{
                userOptions?.sidebar?.isOpen
                    ? 'mdi-menu-open'
                    : 'mdi-menu-close'
            }}
        </v-icon>
        <p
            style="color: #fff;padding: 0;margin: 0 10px 0;"
        >{{ appTitle + ' ' + version }}</p>
        <v-alert
            v-if="
                firstLoad &&
                    currentNotification &&
                    Object.keys(currentNotification).length &&
                        userOptions && userOptions.notifications.isShown
            "
            :type="
                ['success', 'info', 'warning', 'error'].includes(
                    currentNotification.type
                )
                    ? currentNotification.type
                    : 'info'
            "
            elevation="0"
            border="left"
            class="mx-2 my-0 py-0"
        >
            {{ currentNotification.message }}
        </v-alert>
        <v-progress-linear
            v-else-if="!firstLoad && userOptions && userOptions.notifications.isShown"
            color="#fff"
            indeterminate
            class="mx-2 my-0 py-0"
            style="flex: 1"
            rounded
            height="5"
        ></v-progress-linear>
        <v-spacer></v-spacer>
        <v-menu
            v-if="firstLoad"
            offset-y
            :close-on-content-click="false"
            :nudge-width="1200"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-badge
                    :color="notifications.length ? 'warning' : 'success'"
                    overlap
                    :content="notifications.length ? notifications.length : '0'"
                    offset-x="14"
                    offset-y="14"
                    style="margin: 7px 20px 0;"
                >
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="getNotifications()"
                    >
                        <v-icon color="#fff">mdi-bell</v-icon>
                    </v-btn>
                </v-badge>
            </template>
            <v-card style="padding: 0;margin: 0;">
                <v-row style="padding: 0;margin: 0;">
                    <v-col cols="12" style="margin: 0;padding: 0;">
                        <v-toolbar
                            flat
                            dense
                            outlined
                            color="indigo"
                            rounded
                            style="color: #fff;"
                        >
                            <v-app-bar-nav-icon
                                color="#fff"
                            ></v-app-bar-nav-icon>
                            <v-toolbar-title>Notifications</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-text-field
                                v-if="showNotificationSearch"
                                v-model="notificationSearch"
                                label="Search here"
                                hide-details
                                dense
                                solo
                                type="text"
                                style="padding-right: 5px;"
                            ></v-text-field>
                            <v-btn
                                icon
                                color="#fff"
                                @click="
                                    showNotificationSearch = !showNotificationSearch
                                "
                            >
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        color="#fff"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="clearAllNotifications"
                                    >
                                        <v-icon
                                            >mdi-notification-clear-all</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Clear all</span>
                            </v-tooltip>
                            <v-menu
                                v-model="notificationTypeMenu"
                                :close-on-content-click="false"
                                :nudge-width="100"
                                offset-y
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="#fff"
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>

                                <v-card class="mx-auto" max-width="200" tile>
                                    <v-list shaped style="padding: 5px 10px;">
                                        <v-subheader
                                            style="height: 30px;padding: 0;"
                                            >Filter By</v-subheader
                                        >
                                        <v-switch
                                            v-for="filter in notificationFilters"
                                            :key="filter.id"
                                            v-model="filter.model"
                                            inset
                                            :label="filter.name"
                                            dense
                                            hide-details
                                            @change="handleFilterBy"
                                            style="margin: 0;padding-top: 6px;"
                                        ></v-switch>
                                    </v-list>
                                </v-card>
                            </v-menu>
                        </v-toolbar>
                    </v-col>
                </v-row>
                <v-row style="padding: 0;margin: 0;">
                    <v-col cols="12" style="margin: 0;padding: 0;">
                        <v-card
                            style="padding-left: 5px;overflow: scroll;"
                            max-height="500"
                        >
                            <v-card-text
                                v-if="
                                    filteredNotifications.length &&
                                        notifications.length
                                "
                                style="padding-left: 5px;"
                            >
                                <v-row
                                    v-for="notification in filteredNotifications"
                                    :key="notification.id"
                                    style="padding: 0;margin: 0;"
                                >
                                    <v-alert
                                        v-model="notification.show"
                                        dismissible
                                        :color="notification.type"
                                        border="left"
                                        elevation="1"
                                        colored-border
                                        :icon="getIcon(notification)"
                                        @input="
                                            dismissNotifications(notification)
                                        "
                                        max-width="1200"
                                        width="1200"
                                    >
                                        <v-row>
                                            <v-col cols="9">
                                                <v-chip
                                                    style="margin-right: 5px;"
                                                    color="primary"
                                                    small
                                                    label
                                                >
                                                    <v-icon left small>
                                                        mdi-message-badge
                                                    </v-icon>
                                                    {{ notification.author }}
                                                </v-chip>
                                                <v-chip
                                                    style="margin-right: 5px;"
                                                    color="secondary"
                                                    label
                                                    small
                                                    text-color="white"
                                                >
                                                    <v-icon left small>
                                                        mdi-label
                                                    </v-icon>
                                                    {{ notification.subject }}
                                                </v-chip>
                                            </v-col>
                                            <v-col
                                                cols="3"
                                                class="d-flex justify-end"
                                            >
                                                <v-chip
                                                    color="indigo darken-3"
                                                    outlined
                                                    small
                                                >
                                                    <v-icon left>
                                                        mdi-clock-time-four
                                                    </v-icon>
                                                    {{
                                                        formatDatetime(
                                                            notification.created_at
                                                        )
                                                    }}
                                                </v-chip>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="9">
                                                {{ notification.message }}
                                            </v-col>
                                            <v-col
                                                cols="3"
                                                class="d-flex justify-end"
                                                style="align-items: flex-end;"
                                            >
                                                <v-tooltip left>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs
                                                        }"
                                                    >
                                                        <v-chip
                                                            color="black darken-3"
                                                            outlined
                                                            small
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            <v-icon left>
                                                                mdi-eye
                                                            </v-icon>
                                                            View details
                                                        </v-chip>
                                                    </template>
                                                    <div
                                                        v-if="
                                                            notification.details &&
                                                                Object.keys(
                                                                    notification.details
                                                                ).length
                                                        "
                                                    >
                                                        <p
                                                            v-for="key in Object.keys(
                                                                notification.details
                                                            )"
                                                            :key="key"
                                                        >
                                                            <span
                                                                >{{
                                                                    key
                                                                }}: </span
                                                            >
                                                            <span>{{
                                                                notification
                                                                    .details[
                                                                    key
                                                                ]
                                                            }}</span>
                                                        </p>
                                                    </div>
                                                    <p v-else>
                                                        No details to view
                                                    </p>
                                                    <p
                                                        v-else
                                                        style="margin: 0 0 4px;padding: 0;"
                                                    >
                                                        No details to view
                                                    </p>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-alert>
                                </v-row>
                            </v-card-text>
                            <v-card-text
                                v-else-if="notifications.length"
                                style="padding-left: 5px;"
                            >
                                <v-alert
                                    outlined
                                    type="info"
                                    dense
                                    icon="mdi-bell-alert"
                                    style="margin: 0;"
                                    max-width="1200"
                                    width="1200"
                                >
                                    You have notifications, check your filters.
                                </v-alert>
                            </v-card-text>
                            <v-card-text v-else style="padding-left: 5px;">
                                <v-alert
                                    outlined
                                    type="indigo darken-3"
                                    dense
                                    icon="mdi-check-circle"
                                    style="margin: 0;"
                                    max-width="1200"
                                    width="1200"
                                >
                                    You're up to date! No notifications.
                                </v-alert>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </v-menu>
        <v-progress-circular
            v-else
            :size="30"
            style="margin: 0 15px;"
            color="#fff"
            indeterminate
        ></v-progress-circular>
        <v-btn icon disabled>
            <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-menu
            offset-y
            :close-on-click="false"
            :close-on-content-click="false"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon color="#fff">mdi-dots-vertical</v-icon>
                </v-btn>
            </template>
            <v-list dense>
                <v-list-item @click="toggleUserOptions('darkTheme')">
                    <v-icon left>
                        {{
                            userOptions.darkTheme
                                ? 'mdi-white-balance-sunny'
                                : 'mdi-weather-night'
                        }}
                    </v-icon>
                    Switch to
                    {{ userOptions.darkTheme ? 'Light' : 'Dark' }}
                    Theme
                </v-list-item>
                <v-list-item
                    @click="
                        toggleUserOptions('sidebar.expandOnHover'),
                            toggleUserOptions('sidebar.miniVariant')
                    "
                >
                    <v-icon
                        :color="
                            userOptions.sidebar.expandOnHover
                                ? 'success'
                                : 'error'
                        "
                        left
                    >
                        {{
                            userOptions.sidebar.expandOnHover
                                ? 'mdi-arrow-expand-horizontal'
                                : 'mdi-arrow-horizontal-lock'
                        }}
                    </v-icon>
                    {{
                        userOptions.sidebar.expandOnHover
                            ? 'Expand Sidebar on Hover'
                            : 'Lock Sidebar'
                    }}
                </v-list-item>
                <v-list-item @click="toggleUserOptions('sidebar.isOpen')">
                    <v-icon
                        :color="
                            userOptions.sidebar.isOpen ? 'error' : 'success'
                        "
                        left
                    >
                        {{
                            userOptions.sidebar.isOpen
                                ? 'mdi-menu-open'
                                : 'mdi-menu-close'
                        }}
                    </v-icon>
                    {{
                        userOptions.sidebar.isOpen
                            ? 'Close Sidebar'
                            : 'Open Sidebar'
                    }}
                </v-list-item>
                <v-list-item @click="toggleUserOptions('notifications.isShown')">
                    <v-icon
                        :color="
                            userOptions.notifications.isShown ? 'error' : 'success'
                        "
                        left
                    >
                        {{
                            userOptions.notifications.isShown
                                ? 'mdi-lightbulb-off'
                                : 'mdi-lightbulb-on'
                        }}
                    </v-icon>
                    {{
                        userOptions.notifications.isShown
                            ? 'Hide Notifications'
                            : 'Show Notifications'
                    }}
                </v-list-item>
                <v-list-item disabled>
                    <v-icon left>mdi-account</v-icon>
                    Profile
                </v-list-item>
                <v-list-item @click="logout">
                    <v-icon left>mdi-logout</v-icon>
                    Logout
                </v-list-item>
            </v-list>
        </v-menu>
    </v-system-bar>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import Echo from '@/services/Echo.js';

export default {
    name: 'DynamicSystemBar',
    data() {
        return {
            notifications: [],
            currentNotification: {},
            dismissedNotifications: [],
            incomingNotifications: [],
            dismissTimeout: null,
            userPermissions: [],
            firstLoad: false,
            newNotifications: false,
            notificationTypeMenu: false,
            geotabObjects: [],
            notificationFilters: [],
            currentNotificationFilters: [],
            showNotificationSearch: false,
            notificationSearch: '',
            currentUserApp: {},
        };
    },
    computed: {
        filteredNotifications: {
            get: function() {
                const codes = (this.currentNotificationFilters || []).map(
                    filter => {
                        return filter.code;
                    }
                );
                console.log('codes: ', codes);

                let filteredList = this.notifications.filter(notification => 
                    codes.some(filter => notification.subject.includes(filter))
                );

                if (this.showNotificationSearch) {
                    console.log(
                        'Notification search: ',
                        this.notificationSearch
                    );

                    let matchingSearch = [];
                    if (this.currentUserApp.type == 'internal') {
                        matchingSearch = filteredList.filter(notification => {
                            return notification.message
                                .toLowerCase()
                                .includes(this.notificationSearch.toLowerCase());
                        });
                    } else if (this.currentUserApp.type == 'customer') {
                        matchingSearch = filteredList.filter(notification => {
                            return notification.subject
                                .toLowerCase()
                                .includes(this.notificationSearch.toLowerCase());
                        });
                    }

                    console.log(matchingSearch);
                    return matchingSearch;
                } else {
                    console.log('Filtered list', filteredList);
                    return filteredList;
                }
            }
        },
        ...mapGetters('app', [
            'showBar',
            'color',
            'userOptions',
            'appTitle',
            'version'
        ]),
        darkTheme() {
            return this.userOptions.darkTheme;
        }
    },
    async mounted() {
        await this.getCurrentUser();
        this.loadPermissions();

        if (this.currentUserApp.type == 'internal') {
            this.getGeotabObjects();
        } else if (this.currentUserApp.type == 'customer') {
            this.notificationFilters.push({
                id: 1,
                model: true,
                name: 'Order update',
                code: 'Updates for order',
            });
            this.handleFilterBy();
        }

        // Echo.channel('new-notifications-tracker')
        //     .listen('NotificationsCreated', (e) => {
        //         this.newNotifications = e.flag;
        //         console.log("new-notifications-tracker: ", this.newNotifications);

        //         // this.notifications = this.incomingNotifications;
        //         // this.notifications.map(notification => {
        //         //     notification.show = true;
        //         // });
        //     });
    },
    watch: {
        darkTheme() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        }
    },
    methods: {
        //Change the notification every 5 seconds
        changeCurrentNotification() {
            if (this.notifications.length) {
                this.currentNotification = this.notifications[
                    Math.floor(Math.random() * this.notifications.length)
                ];
            } else {
                this.currentNotification = {}; // Ensure it's an empty object if no notifications
            }
        },
        getIcon(notification) {
            return notification.type == 'warning'
                ? 'mdi-exclamation-thick'
                : notification.type == 'info'
                ? 'mdi-information'
                : notification.type == 'error'
                ? 'mdi-alert'
                : 'mdi-information';
        },
        dismissNotifications(notification) {
            // Remove locally
            const index = this.notifications.findIndex(
                item => item.id === notification.id
            );
            if (index !== -1) {
                this.notifications.splice(index, 1);
            }

            // Reset current notification
            if (!this.notifications.length) {
                this.currentNotification = {};
            }

            // Set status to read
            this.dismissedNotifications.push(notification);
            console.log(this.dismissedNotifications);
            this.triggerDismiss();
        },
        triggerDismiss() {
            clearTimeout(this.dismissTimeout); // Clear previous timeout
            this.dismissTimeout = setTimeout(() => {
                this.sendDismissedNotifications(10);
            }, 3000);
        },
        sendDismissedNotifications(dismissType = 10) {
            const params = {
                dismissedNotifications: this.dismissedNotifications,
                type: dismissType
            };
            axios
                .post('notifications/dismiss', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.dismissedNotifications = [];
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getNotifications() {
            axios
                .get('notifications', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log('Notifications: ', response.data);
                    this.notifications = response.data.map(notification => {
                        let data = notification.data;
                        if (typeof data === 'string') {
                            data = JSON.parse(data);
                        }
                        data.id = notification.id;
                        return data;
                    });

                    console.log(this.notifications);
                    this.notifications.map(notification => {
                        notification.show = true;
                    });

                    console.log(this.notifications);

                    if (!this.firstLoad) {
                        this.firstLoad = true;
                    }

                    this.cycleNotifications();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        cycleNotifications() {
            if (this.firstLoad) {
                this.changeCurrentNotification();
            }
            setTimeout(() => {
                this.cycleNotifications();
            }, 5000);
        },
        loadPermissions() {
            let permissions = localStorage.getItem('permissions');
            if (permissions) {
                this.userPermissions = JSON.parse(permissions);
                this.getNotifications();
            } else {
                setTimeout(() => {
                    this.loadPermissions();
                }, 5000);
            }
        },
        formatDatetime(datetimeString) {
            const [date, timeWithMilliseconds] = datetimeString.split(' ');
            const [time] = timeWithMilliseconds.split('.');
            const formattedDatetime = `${date} ${time}`;
            return formattedDatetime;
        },
        async getCurrentUser() {
            await axios
                .get('user/current', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    let user = response.data;
                    this.currentUserApp = user;
                    console.log(this.currentUserApp);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        getGeotabObjects() {
            axios
                .get('geotab/objects', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.geotabObjects = response.data;
                    console.log('Geotab Objects: ', this.geotabObjects);
                    const objs = [1, 2, 3];
                    this.notificationFilters = this.geotabObjects.filter(
                        obj => {
                            return objs.includes(obj.id);
                        }
                    );
                    this.notificationFilters.map(filter => {
                        filter.model = true;
                    });
                    console.log(
                        'Notification filters: ',
                        this.notificationFilters
                    );
                    this.handleFilterBy();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        handleFilterBy() {
            this.currentNotificationFilters = this.notificationFilters.filter(
                filter => filter.model
            );
            console.log('Filter By: ', this.currentNotificationFilters);
        },
        clearAllNotifications() {
            this.dismissedNotifications = this.filteredNotifications;
            console.log('Clear all: ', this.dismissedNotifications);
            const ids = this.dismissedNotifications.map(
                notification => notification.id
            );
            this.notifications = this.notifications.filter(
                notification => !ids.includes(notification.id)
            );
            this.sendDismissedNotifications(13);
        },
        ...mapActions('app', ['updateUserOption']),
        toggleUserOptions(option) {
            const keys = option.split('.');
            let currentValue = this.userOptions;

            // Traverse the nested properties to get the current value
            for (let i = 0; i < keys.length - 1; i++) {
                if (!currentValue[keys[i]]) {
                    console.error(`Invalid key path: ${option}`);
                    return;
                }
                currentValue = currentValue[keys[i]];
            }

            // Toggle the final property in the path
            const finalKey = keys[keys.length - 1];
            const newValue = !currentValue[finalKey];
            // Call the Vuex action to update the state
            this.updateUserOption({
                key: option,
                value: newValue
            });
        },
        showSnackbar(message) {
            this.$store.dispatch('setSnackbar', {
                show: true,
                color: this.darkTheme ? 'dark' : 'light',
                mode: 'multi-line',
                text: message
            });
        },
        ...mapActions('auth', ['logout']),
        async handleLogout() {
            try {
                await this.logout();
                // Redirect to login page
            } catch (error) {
                console.error('Logout failed:', error);
            }
        }
    }
};
</script>

<style scoped>
.bouncing-icon {
    font-size: 36px;
    animation: bounce 2s ease-in-out infinite;
}

@keyframes bounce {
    0%,
    100% {
        transform: translateY(0) scale(1);
    }
    50% {
        transform: translateY(-2px) scale(1.05);
    }
}

.bouncing-icon:nth-child(1) {
    animation-delay: 0s;
}

.bouncing-icon:nth-child(2) {
    animation-delay: 0.3s;
}

.bouncing-icon:nth-child(3) {
    animation-delay: 0.6s;
}
</style>
